import styled from "styled-components";

export const StyledStoreDetails = styled.div`
    width: 100%;

    .upload-wrap {
        .label {
            display: block;
        }
        .label-title {
            display: block;
            margin-bottom: 12px;
            font-size: 18px;
            line-height: 22px;
            font-weight: 500;
        }
        .size-desc {
            display: block;
            font-size: 14px;
            line-height: 18px;
            font-weight: 400;
            color: rgba(143, 143, 143, 1);
        }
        .labelButton {
            background-color: var(--white);
            border: 1px dashed rgba(205, 205, 205, 1);
            .icon-img {
                width: 35px;
            }
            .text-lg {
                color: rgba(143, 143, 143, 1);
                font-size: 12px;
                line-height: 16px;
                font-weight: 300;
                margin-bottom: 16px;
            }
            .text {
                width: max-content;
                border: 1px solid rgba(225, 228, 232, 1);
                color: var(--text-color);
                border-radius: 60px;
                padding: 10px 25px;
                font-size: 16px;
                line-height: 20px;
                font-weight: 400;
            }
        }
    }
`;
